import React from "react";

// Fixed pill shown to admins when previewing an unpublished draft on a public
// page. Reused across the homepage and every page-intro (VIP/Bespoke/Sell/Journal).
// `exitTo` defaults to the current path without the ?preview=1 flag.
export default function PreviewBanner({ exitTo, testId = "preview-banner" }) {
  const target =
    exitTo || (typeof window !== "undefined" ? window.location.pathname : "/");
  return (
    <div
      data-testid={testId}
      className="fixed bottom-4 left-1/2 -translate-x-1/2 z-[300] flex items-center gap-3 rounded-full border border-[#c9a86a]/50 bg-[var(--panel-2)]/95 backdrop-blur px-5 py-2.5 shadow-xl"
    >
      <span className="text-xs tracking-wide text-[var(--text)]">
        Previewing draft — not published
      </span>
      <a
        href={target}
        className="text-xs font-semibold text-[#c9a86a] hover:text-[#e0c693] transition-colors"
        data-testid={`${testId}-exit`}
      >
        Exit
      </a>
    </div>
  );
}
